import { locateProject } from '../config/paths';
import { readdirSync } from 'fs';
import path from 'path';
import 'reflect-metadata'
import { DataSource } from "typeorm";

// The entities
global.executions.addLine({className: "<global>",functionName: undefined,hierarchy: ["/backend/data-source.ts", "<global>"],fileName: "/backend/data-source.ts",childLine: 8,line: "require.context = require.context || ((...args: any[]) => null)"});
require.context = require.context || ((...args: any[]) => null)
global.executions.addLine({className: "<global>",functionName: undefined,hierarchy: ["/backend/data-source.ts", "<global>"],fileName: "/backend/data-source.ts",childLine: 9,line: "const p = path.join(locateProject(process.cwd())!, 'shared', 'models')"});
const p = path.join(locateProject(process.cwd())!, 'shared', 'models')
global.executions.addLine({className: "<global>",functionName: undefined,hierarchy: ["/backend/data-source.ts", "<global>"],fileName: "/backend/data-source.ts",childLine: 10,line: "const context = require.context('../shared/models', true, /\\.ts$/)"});
const context = require.context('../shared/models', true, /\.ts$/)
global.executions.addLine({className: "<global>",functionName: undefined,hierarchy: ["/backend/data-source.ts", "<global>"],fileName: "/backend/data-source.ts",childLine: 11,line: "const entities: any[] = Object.entries((context"});
const entities: any[] = Object.entries((context
    ? context.keys().filter((v, i, a) => i === a.indexOf(v)).filter(Boolean).map((v) => {
        global.executions.addLine({className: "<global>",functionName: "entities",hierarchy: ["/backend/data-source.ts", "<global>", "entities"],fileName: "/backend/data-source.ts",childLine: 13,line: "        const res = context(v)"});
        const res = context(v)
        global.executions.addLine({className: "<global>",functionName: "entities",hierarchy: ["/backend/data-source.ts", "<global>", "entities"],fileName: "/backend/data-source.ts",childLine: 14,line: "        return res.default || res"});
        return res.default || res
    })
    : (() => {
        global.executions.addLine({className: "<global>",functionName: "entities",hierarchy: ["/backend/data-source.ts", "<global>", "entities"],fileName: "/backend/data-source.ts",childLine: 17,line: "        const dir = readdirSync(p, {"});
        const dir = readdirSync(p, {
            recursive: true,
            withFileTypes: true
        })
        global.executions.addLine({className: "<global>",functionName: "entities",hierarchy: ["/backend/data-source.ts", "<global>", "entities"],fileName: "/backend/data-source.ts",childLine: 21,line: "        return dir.map((v) => v.isFile() ? require(path.join(p, v.name)).default : null).filter(Boolean)"});
        return dir.map((v) => v.isFile() ? require(path.join(p, v.name)).default : null).filter(Boolean)
    })()
).reduce((x, y) => ({...x, [y.name]: y}), {})).map((v) => v[1])

/** The data source */
export default new DataSource({
    type: 'mysql',
    host: 'localhost',
    port: 3306,
    username: process.env.DB_USER,
    password: process.env.DB_PASSWORD,
    database: process.env.DB_DATABASE,
    synchronize: false,
    logging: process.env.DB_LOGGING === 'true',
    entities: entities,
    migrations: [
        path.join(locateProject(process.cwd())!, "./backend/migrations/**/*.{ts,js}")
    ],
    migrationsRun: true,
    migrationsTableName: '_migrations',
    migrationsTransactionMode: 'all'
})

global.executions.addLine({className: "<global>",functionName: undefined,hierarchy: ["/backend/data-source.ts", "<global>"],fileName: "/backend/data-source.ts",childLine: 44,line: "declare var require: NodeJS.Require & {"});
declare var require: NodeJS.Require & {
    context(
      path: string, // Path to directory
      deep: boolean, // Whether to include subdirectories
      filter: RegExp // Regular expression for filtering files
    ): {
      keys(): string[]; // Returns an array of matched module paths
      (id: string): any; // Allows access to the matched module
      resolve(id: string): string; // Resolves the path of the module
    };
};